import api from 'service/api'

const trainingPortalAPI = api.create('trainingPortal', false)

const show = async () => trainingPortalAPI.get('/profile')

const update = async (data) =>
  trainingPortalAPI.put('/profile', { profile: data })

export default {
  show,
  update,
}
